import React                       from 'react';
import CompetitionsWinners         from './CompetitionsWinners';
import Translations                from '../../utils/Translations';
import withCompetitions            from '../HigherOrderComponents/Competitions/withCompetitions';
import ReloadHelper                from '../../utils/ReloadHelper';
import PropTypes                   from 'prop-types';
import VXButton                    from "../SimpleElements/VXButton/VXButton";
import {COLOR_TYPE_CALL_TO_ACTION} from "../SimpleElements/VXButton/ButtonHelper";
import {VXButtonLineConfig}        from "../SimpleElements/VXButton/VXButtonConfig";
import {generateKey}               from '../../utils/CommonUtils';

class Competitions extends React.Component {

    constructor(props) {
        super(props);
        this.onClickUrlHandler = this.onClickUrlHandler.bind(this);
    }

    onClickUrlHandler(e, url = this.props.contestsLink) {
        ReloadHelper.reload(url, e);
    }

    setRef(ref) {
        if (ref) {
            this.props.parentCallback(ref);
        }
    }

    render() {
        const {as: Tag, contests, contestsLink} = this.props;

        if (!contests) {
            return null;
        }

        const {current, passed} = contests;
        return (
                <Tag className="homepage-block competitions-block" id="contests-block" ref={(ref) => this.setRef(ref)}>
                    {
                        current ?
                                <div className="competitions competitions-active">
                                    <a className="competitions-active__poster"
                                       href={current.linkVX}
                                       onClick={this.onClickUrlHandler}>
                                        <img src={current.previewUrl} loading={"lazy"} />
                                    </a>
                                    <div className="competitions-active__info">
                                        <div className="competitions--status active">{Translations.get('Active')}</div>
                                        <div className="competitions-active__info--title">{Translations.get('VoteForYourFavorite')}</div>
                                        <div className="competitions-active__info--description">{Translations.get('FreeUncensored')}</div>
                                        <VXButton line1={[new VXButtonLineConfig(Translations.get('VoteHere'))]}
                                                  color={COLOR_TYPE_CALL_TO_ACTION}
                                                  link={contestsLink}
                                        />
                                    </div>
                                </div>
                                :
                                <div className="competitions competitions-completed">
                                    {
                                        passed.map((contest, index) =>
                                                <a href={contest.linkVX}
                                                   key={generateKey(contest.title, index)}
                                                   onClick={(e) => this.onClickUrlHandler(e, contest.linkVX)}
                                                   className="competitions-completed__item--wrapper">
                                                    <CompetitionsWinners
                                                            previewUrl={contest.previewUrl}
                                                            type={contest.type}
                                                            title={contest.title}
                                                    />
                                                </a>
                                        )
                                    }
                                    <div className="competitions-completed__description">
                                        <div className="competitions--status completed">{Translations.get('Ended')}</div>
                                        <br />
                                        <h2 className="competitions-completed__description--title">{Translations.get('WinnersOfTheLastCompetitions')}</h2>
                                        <div className="competitions-completed__description--info">{Translations.get('AllVideosSelfies')}</div>
                                        <VXButton line1={[new VXButtonLineConfig(Translations.get('WatchForFree'))]}
                                                  color={COLOR_TYPE_CALL_TO_ACTION}
                                                  link={contestsLink}
                                        />
                                    </div>
                                </div>
                    }
                </Tag>
        );
    }
}

Competitions.propTypes = {
    as:             PropTypes.string,
    contests:       PropTypes.object,
    contestsLink:   PropTypes.string,
    contestData:    PropTypes.object,
    parentCallback: PropTypes.func,
};

Competitions.defaultProps = {
    as: 'div',
};

export default withCompetitions(Competitions);
